var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/outlined/hash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75084 2.44518C8.05731 2.49605 8.26451 2.78572 8.21365 3.09219L6.2219 15.0922C6.17103 15.3987 5.88136 15.6059 5.57489 15.555C5.26842 15.5042 5.06122 15.2145 5.11208 14.908L7.10383 2.90798C7.1547 2.60152 7.44437 2.39431 7.75084 2.44518ZM12.4258 2.44518C12.7322 2.49605 12.9394 2.78572 12.8886 3.09219L10.8968 15.0922C10.846 15.3987 10.5563 15.6059 10.2498 15.555C9.94335 15.5042 9.73614 15.2145 9.78701 14.908L11.7788 2.90798C11.8296 2.60152 12.1193 2.39431 12.4258 2.44518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18799 6.75007C3.18799 6.43941 3.43983 6.18757 3.75049 6.18757H14.2505C14.5611 6.18757 14.813 6.43941 14.813 6.75007C14.813 7.06073 14.5611 7.31257 14.2505 7.31257H3.75049C3.43983 7.31257 3.18799 7.06073 3.18799 6.75007ZM3.18799 11.2501C3.18799 10.9394 3.43983 10.6876 3.75049 10.6876H14.2505C14.5611 10.6876 14.813 10.9394 14.813 11.2501C14.813 11.5607 14.5611 11.8126 14.2505 11.8126H3.75049C3.43983 11.8126 3.18799 11.5607 3.18799 11.2501Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashWhite);
export default __webpack_public_path__ + "static/media/hash_white.0227ace23919bc4581d732b3fb65442c.svg";
export { ForwardRef as ReactComponent };